import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { LoginResponseAuthorizedMenu } from '../models/response/user/LoginResponse';

/**
 * Personel ücret geçmişi (11.10.2026). Ücret tarihli tutulur; zam sonrası eski ayların puantajı eski ücretle hesaplanır.
 * Maaş hassas veridir: yalnız bu menü yetkisi olan roller görür (yetki bayrağı, rotası / yan menüsü yok).
 */
export const PERSONEL_UCRETLERI_MENUSU = "İnsan Kaynakları > Tanımlamalar > Personel Ücretleri";

export const personelUcretYetkisi = (menuler: LoginResponseAuthorizedMenu[] | undefined | null) =>
    menuler?.some(x => x.menuName == PERSONEL_UCRETLERI_MENUSU) ?? false;

export interface PersonelUcret {
    personelUcretId: string
    personnelId: string
    /** "yyyy-MM-dd" */
    gecerlilikBaslangic: string
    /** "dd.MM.yyyy" */
    gecerlilikBaslangicStr: string
    aylikMaas: number
    saatlikUcret: number
    aciklama?: string | null
    /** Bugün geçerli olan kayıt. */
    gecerli: boolean
    createdUser: string
    createdDate: string
    updatedUser: string
    updatedDate: string
}

export interface PersonelUcretKaydetIstek {
    personelUcretId?: string
    personnelId: string
    gecerlilikBaslangic: string
    aylikMaas: number
    saatlikUcret: number
    aciklama?: string
}

interface Yanit<T> { isSuccess: boolean, message?: string, data: T }

const cagir = async <T>(uc: string, govde: any = {}): Promise<Yanit<T>> => {
    try {
        console.log('SERVICE CALL - Personnel/' + uc, JSON.stringify(govde));
        const resp = await axios.post(Helpers.getEndpoint() + '/Personnel/' + uc, govde);
        return Helpers.dataParser(resp);
    } catch (error) {
        throw Helpers.parseErrorMessage(error);
    }
}

export class PersonelUcretService {
    static liste = (personnelId: string) => cagir<PersonelUcret[]>('UcretListesi', { personnelId });
    static kaydet = (istek: PersonelUcretKaydetIstek) => cagir<PersonelUcret>('UcretKaydet', istek);
    static sil = (ids: string[]) => cagir<boolean>('UcretSil', { ids });
}
